  <template>

    <div class="modal-card">

        <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

       
        <section class="modal-card-body">
                  <!-- {{departmentArr}}   -->
         

                    <b-field label="Select a date">
                        <template #label>
                            Select a date
                            <span class="has-text-danger">*</span>
                        </template>
                        <b-datepicker
                            v-model = "monthSelected" 
                            type="month"
                            placeholder="Click to select..."
                            icon="calendar-today"
                            trap-focus>
                        </b-datepicker>
                    </b-field>
               
            

                    <div  class="box" >
                                        <b-taglist>
                                                        <b-tag 
                                                            v-for="dat in departmentSelected"  :key="dat.iddepartment"
                                                            size="is-medium"
                                                            type="is-info is-light"
                                                            close-type='is-danger'
                                                            close-icon-type='is-dark'
                                                            closable
                                                            close-icon='delete'
                                                            aria-close-label="Close tag"
                                                            @close="closeDepartmentSelected(dat)">
                                                            {{dat.name}} 
                                                        </b-tag>
                                        </b-taglist>
                    </div>





                     <nav class="level is-mobile">
						<div class="level-left">
							<div class="level-item">
 <b-input placeholder="อายุรกรรมสัตว์ป่วยนอก ในเวลา" v-model="searchDepartmentTxt"></b-input>	 
							</div>
						</div>
						<div class="level-right">
   <div class="level-item">
                             
                           </div>
                            <div class="level-item">
                           </div>
						</div>
    </nav>  



                  
         
                   <b-table  
                          :data="isEmpty ? [] : departmentfilter"
                          bordered
                          striped
                          narrowed
                          hoverable
                          focusable
                          mobile-cards
                          paginated
                          :current-page.sync="currentPage"
                          :per-page="perPage">
                         <b-table-column  label="ชื่อแผนก"    v-slot="props">
                           <text-highlight :queries="queries">   {{props.row.name}} </text-highlight>
                         </b-table-column>

                          <b-table-column  label="#"    v-slot="props">
                              <b-switch v-model="props.row.check"
                                type="is-success">
                                 
                               </b-switch>
                       
                          </b-table-column>


                     </b-table>     
          
        </section>
        <footer class="modal-card-foot"  style="justify-content: space-between;">

            <b-button type="is-danger" @click="close">Close</b-button>
            

             <b-button type="is-success"
                          icon-left="share"  @click="genReport"
                           >
                    Generate and Send
             </b-button>
 
        </footer>
    </div>



   
</template>

<script>
import axios from "axios"
import {   getBaseURLforBackEnd  , getConfigAxios  , myTimeZone } from '@/utils.js'
import { mapState} from "vuex";
import moment from 'moment-timezone' 




export default {
    name : "ReportI002",
    props:{
        isComponentModalActive : Boolean,
    },
    computed:{
            ...mapState({            
                access_token : state => state.master_data.access_token,
            }) ,
            departmentSelected(){
                return  this.departmentArr.filter(dat=>{
                    return dat.check
                    })
            },
            departmentfilter(){
                return this.departmentArr.filter(dat=>{
                    return  dat.name.toUpperCase().indexOf(this.searchDepartmentTxt.toUpperCase()) > -1
                })
            },

            departmentfilterForDatTo(){
                // const dat = this.departmentArr.filter(dat=>{
                //     return   dat.check
                // })

                // return dat.map(element=>{
                //     return {
                //         "iddepartment" : element.iddepartment
                //     }
                // })
                
                return this.departmentArr
                        .filter(dat=>dat.check)
                        .map(dat=>   {
                               return{ "iddepartment" : dat.iddepartment}
                            })  

            },


            queries(){
                return this.searchDepartmentTxt.split(" ");
            } 
    }, 
    methods:{
         closeDepartmentSelected(payload){
             const tmp =  this.departmentArr.find(dat => dat.iddepartment == payload.iddepartment)
             if(tmp){
                 tmp.check = false
             }           
         },
         close(){
           this.$emit('close')
         },

         genReport(){
             const vm = this
             if(this.departmentfilterForDatTo.length==0){
                 vm.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'pls select some department',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'close-box',
                    ariaRole: 'alertdialog',
                    ariaModal: true
                })
                return
             }
             const datTo = {
                 "month" :  moment.tz(   this.monthSelected , myTimeZone).format('YYYY-MM-DD') +'T'+ moment.tz(  this.monthSelected , myTimeZone).format('HH:mm') +':00.000Z'  ,
                 "department" : this.departmentfilterForDatTo
             }

            //  console.log(JSON.stringify(datTo))

             this.isFullScreenSearching = true
            
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/reporti02`,datTo,getConfigAxios())
                    .then( (res) => {
                      this.isFullScreenSearching = false
                      vm.$buefy.toast.open({
                            duration: 5000,
                            message: `${res.data.msg}`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                      vm.$emit('close')  
                    })
                    .catch(()=>{
                      this.isFullScreenSearching = false   
                      vm.$buefy.toast.open({
                            duration: 5000,
                            message: `something error`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                    })

         },  

         loadCurrentDateTime(){
                this.isFullScreenSearching = true
                // console.log("loadCurrentDateTime")
                const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.get(`${getBaseURLforBackEnd()}/api/curdatetime`,getConfigAxios())
                    .then(function (response) {
                        // vm.monthSelected = new Date( moment( response.data.current_datetime_iso , myTimeZone ) )
                        vm.monthSelected = new Date( Date.parse(response.data.current_datetime_iso) ) 
                        vm.isFullScreenSearching = false
                        console.log("loadCurrentDateTime complete")
                        const tmp = moment(  response.data.current_datetime_iso , myTimeZone  ).format("YYYY-MM-DD") 
                        console.log( tmp )
                        console.log(new Date( Date.parse(response.data.current_datetime_iso) ))
                    }) 
         },   
         loadDepartment(){
             this.isFullScreenSearching = true
             const vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/list_of_departmentappoint`,getConfigAxios())
                    .then(function (response) {
                        // console.log(response.data)
                        vm.departmentArr = response.data
                        vm.departmentArr =   vm.departmentArr.map(obj=> ({ ...obj, 'check': false }))
                        vm.isFullScreenSearching = false
                    })
                 
        },
    },
    data(){
        return {
             hasMonthYearSelected : false,
          

             departmentArr : [],
             isLoadingFullPage : false,

             isEmpty : false,

             currentPage : 1,
             perPage : 20,


             searchDepartmentTxt : "", 


             monthSelected : null,


        }
    },
    watch:{
        isComponentModalActive : {
            immediate : true,
            handler : function(val){
                if(val){
                    this.loadDepartment()
                    this.loadCurrentDateTime()
                }
            }
        } 
    }
}
</script>





 
  
 
